module.exports = __webpack_public_path__ + "static/the-signal-and-the-noise-c994b0d56c7deff69798c5a04ce9c670.jpg";